export default __webpack_public_path__ + "static/media/ruby-on-rails-r-bg.1710acce.png";